export const baseUrl = "https://api.themoviedb.org/3";
export const API_KEY = "01a25a80069fced48bd4a773e12f3f16";
export const imageUrl = "https://image.tmdb.org/t/p/original"